/**
 * Handle Table/Input Group Page Break Adjustments for PDF Export
 *
 * This method directly manipulates the DOM elements to adjustment them for
 * page breaking.
 *
 * @param {Element} ref //Represents the direct table/inputGroup parent element of the all the rows in the field
 * @param {Array} pageBreakPointsPixels //Array of numbers (pixel positions) where page break adjustments are required
 * @param {Object} styles //Any styles that need applied to the adjustments
 */
const handleTableFieldPageBreakAdjustments = (ref, pageBreakPointsPixels, styles) => {

  if (!ref || !pageBreakPointsPixels) return;

  const childTableRows = Array.from(ref.children);

  //Do not remove the default 0! Default styled tables breaks without it.
  let rowTopPixels = styles.borderWidth || 1;

  childTableRows.forEach((row) => {

    const rowHeightPixels = row.offsetHeight;
    let rowBottomPixels = rowTopPixels + rowHeightPixels;

    const pageBreakIntersection = pageBreakPointsPixels.find((pageBreakIntersection) => {

      //Return any intersection point that conflicts with the row dimensions
      if (rowTopPixels < pageBreakIntersection && rowBottomPixels > pageBreakIntersection) return true;
      else return false;

    });

    /**
     * Only adjust row if it intersects with a page break
     */
    if (pageBreakIntersection) {

      const pageBreakPaddingPixels = (pageBreakIntersection - rowTopPixels) + 18;
      rowBottomPixels += pageBreakPaddingPixels;

      row.style.marginTop = `${pageBreakPaddingPixels}px`;

      /**
       * Why is borderTop disabled?
       *
       * Originally I wanted to add a border to the top of the row that is page break adjusted.
       * I disabled that logic for now because it was introducing errors with the page breaks
       * happening in the correct spot. I left this in to remind the devs that this causes an
       * issue and will need additional debugging and consideration.
       */
      //row.style.borderTop = border;

    }

    rowTopPixels = rowBottomPixels;

  });

};

export default handleTableFieldPageBreakAdjustments;
